function popupRules(app) {
  return {
    floorName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.popup.system.floor.label.floorName'),
          length: 50
        }),
        trigger: 'blur'
      }
    ]
  }
}

export default {
  popupRules: popupRules
}
